export const inServer = process.env.BUILD_TARGET === 'server';
export const SERVER_RENDER_BREAKPOINT = '__SERVER_RENDER_BREAKPOINT__';
export const COOKIE_FAVORITES = 'kvanum-favorites';
export const COOKIE_CONSENT = 'kvanum-consent';
export const DEFAULT_CONTACT_EMAIL = 'marknad@kvanum.com';